module.exports = __webpack_public_path__ + "img/iconfont.1cb32b97.svg";